import React from "react";
import { Box, Typography } from "@mui/material";
import { HtmlTooltip } from "../StyledComponents/styled";

const TruncatedText = ({ text, tooltipText, variant = "body2", sx }) => {
  const textRef = React.useRef(null);
  const [truncated, setTruncated] = React.useState(false);
  const full = String(text ?? "");
  const tooltip = tooltipText == null ? full : String(tooltipText);
  const showTooltip = truncated || (tooltip !== "" && tooltip !== full);

  const updateTruncation = React.useCallback(() => {
    const el = textRef.current;
    if (!el) {
      return;
    }
    setTruncated(el.scrollWidth > el.clientWidth + 1);
  }, []);

  React.useLayoutEffect(() => {
    updateTruncation();
  }, [full, updateTruncation]);

  React.useEffect(() => {
    const el = textRef.current;
    if (!el || typeof ResizeObserver === "undefined") {
      return undefined;
    }
    const observer = new ResizeObserver(() => {
      updateTruncation();
    });
    observer.observe(el);
    if (el.parentElement) {
      observer.observe(el.parentElement);
    }
    return () => observer.disconnect();
  }, [updateTruncation]);

  return (
    <HtmlTooltip title={showTooltip ? tooltip : ""}>
      <Box sx={{ minWidth: 0, width: "100%", maxWidth: "100%", overflow: "hidden", flex: "1 1 0%" }}>
        <Typography
          ref={textRef}
          variant={variant}
          noWrap
          sx={{
            ...sx,
            display: "block",
            minWidth: 0,
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {full}
        </Typography>
      </Box>
    </HtmlTooltip>
  );
};

export default TruncatedText;
